import { ID } from '../../utils/codecUtils';
import { SavedView } from '../models/savedView';
import { savedViewSchema } from '../models/savedView.schema';
import { patchSavedViewPayloadSchema } from './patch.schema';

export type SavedViewPatchableFields = Pick<
  SavedView,
  'name' | 'query' | 'shared' | 'queuesFilter'
>;

export type PatchSavedViewPayload = Partial<SavedViewPatchableFields>;

export const patch = (savedViewId: ID, payload: PatchSavedViewPayload) => {
  return {
    endpoint: `/saved_views/${savedViewId}`,
    method: 'PATCH',
    payload,
    responseSchema: savedViewSchema,
    payloadSchema: patchSavedViewPayloadSchema,
  } as const;
};
